// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__wvU9U","loader":"loader_loader__isgS3"};